import React from "react";
function formatDateTime(dateTimeStr) {
  if (!dateTimeStr) return "";

  const [datePart, timePart] = dateTimeStr
    .replace("T", " ")
    .split(" ");

  const [y, m, d] = datePart.split("-");
  const [hh = "00", mm = "00" , ss = "00"] = (timePart || "").split(":");

  return `${d}-${m}-${y} ${hh}:${mm}:${ss}`;
}

class InventoryComponent extends React.Component {
  constructor(props) {
    super();
    this.state = {
      item_id: "",
      item_name:"",
      request_date: "",
      quantity:"",
    };
  }
   updateInventoryitemState = (item) => {
    this.setState({
      item_id: item.id,
      request_date: item.request_date,
      quantity: item.quantity,
      
    });
  };
  render() {
    const { inventory, products } = this.props;
   

    return (
      <div>
        {/* Add Inventory Modal */}
        <div className="modal fade" id="inventoryModal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4>Add Inventory Entry</h4>
                <button className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              <div className="modal-body">
                <form>
                  {/* Product */}
                  <div className="form-group">
                    <label>Product</label>
                    <select
                      className="form-control"
                      onChange={this.props.onProductChange}
                    >
                      <option value="">Select Product</option>
                      {products.map((p) => (
                        <option
                          key={p.id}
                          value={p.id}
                          >
                          {p.stock_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Date */}
                  <div className="form-group">
                    <label>Date</label>
                    <input
                      type="date"
                      className="form-control"
                      onChange={this.props.onDateChange}
                    />
                  </div>

                  {/* Quantity */}
                  <div className="form-group">
                    <label>Quantity Received</label>
                    <input
                      type="number"
                      className="form-control"
                      onChange={this.props.onQuantityChange}
                    />
                  </div>

                  <button
                    className="btn btn-primary"
                    onClick={this.props.addInventory}
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Inventory Table */}
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h3>Daily Inventory</h3>
            <button
              className="btn btn-primary"
              data-toggle="modal"
              data-target="#inventoryModal"
            >
              Add Inventory
            </button>
          </div>

          <div className="card-body">
            <table className="table text-center">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Product</th>
                  <th>Date</th>
                  <th>Quantity Received</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {inventory && inventory.length > 0 ? (
                  inventory.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        {
                          products.find(
                            (p) =>
                              p.inventory_item_id === item.product_id
                          )?.stock_name || "-"
                        }
                      </td>

                      <td>{formatDateTime(item.request_date)}</td>
                      <td>{item.quantity}</td>

                      <td>
                        <i
                            className="fa fa-edit mr-2"
                            data-toggle="modal"
                            data-target="#updateinventoryitemModal"
                            onClick={() => this.updateInventoryitemState(item)}
                          ></i>
                        <i
                          className="fa fa-trash"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            window.confirm("Delete entry?") &&
                            this.props.deleteInventory(item.id)
                          }
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No Inventory Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
          {/* update Inventory Modal */}
        <div className="modal fade" id="updateinventoryitemModal" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Inventory Entry</h4>
                  <button type="button" className="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
              </div>

              <div className="modal-body">
                <form>
                  {/* Product */}
                  <div className="form-group">
                    
                    
                  </div>

                  {/* Date */}
                  <div className="form-group">
                    <label>Date {formatDateTime(this.state.request_date)}</label>
                    <input
                      type="date"
                      className="form-control"
                      onChange={this.props.onDateChange}
                    />
                  </div>

                  {/* Quantity */}
                  <div className="form-group">
                    <label>Quantity Received</label>
                    <input
                      type="number"
                      className="form-control"
                      value={this.state.quantity}
                      onChange={this.props.onQuantityChange}
                    />
                  </div>
                  <button
            type="button"
            className="btn btn-primary"
            onClick={this.props.updateInventory}
            data-dismiss="modal"
          >
            UPDATE
          </button>
                  
                </form>
              </div>
            </div>
          </div>
        </div>      
      </div>
    );
  }
}

export default InventoryComponent;
